module.exports = __webpack_public_path__ + "rijksoverheidsanstext-bolditalic_2_0.woff?53ee9085cb180912c2ad73398591dabc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rijksoverheidsanstext-bolditalic_2_0.woff
// module id = 544
// module chunks = 0